import { OktaUserInfo } from '@brightside/core/auth';

export interface ClientSubjectData {
  links: [{label: string, url: string}];
  isEligible: boolean;
  firstName: string;
  lastName: string;
  company: string;
  guid: string;
  gender: string;
  employmentType: string;
  state: string;
  city: string;
  dateOfBirth: string;
  annualPay?: number;
  hireDate?: string;
  pronouns?: string;
  assignedFaName?: string;
  householdDependents?: number;
  firstInteractionDate?: string;
  mostRecentInteractionDate?: string;
}

export interface UiSession {
  uiSessionId: string;
  oktaUserId: string;
  subjectId: string;
  subjectType: string;
  conversationId?: string;
  createdDate: string;
  subjectData: ClientSubjectData;
  state: 'active' | 'archived';
  oktaUser?: OktaUserInfo;
}



export interface UiSessionsResponse {
  payload: { uiSessions: UiSession[] };
}

export interface SingleUiSessionsResponse {
  payload: { uiSession: UiSession };
}

export interface UiSessionResponse {
  payload: UiSession;
}

export interface SubjectDataResponse {
  payload: ClientSubjectData;
}
